import axios from 'axios';
import config from '../config/environment';
import { Ticket, CreateTicketRequest, UpdateTicketRequest, TicketFilters, TicketComment } from '../types/ticket';

const api = axios.create({
  baseURL: config.apiUrl,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Get all tickets for a project with optional filters
export const getTickets = async (projectId: string, filters?: TicketFilters): Promise<Ticket[]> => {
  const params = new URLSearchParams();
  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (value) params.append(key, value);
    });
  }
  const response = await api.get(`/projects/${projectId}/tickets?${params.toString()}`);
  return response.data.data;
};

// Get a single ticket with comments
export const getTicket = async (projectId: string, ticketId: string): Promise<Ticket> => {
  const response = await api.get(`/projects/${projectId}/tickets/${ticketId}`);
  return response.data.data;
};

// Create a new ticket
export const createTicket = async (projectId: string, data: CreateTicketRequest): Promise<Ticket> => {
  const response = await api.post(`/projects/${projectId}/tickets`, data);
  return response.data.data;
};

// Update a ticket
export const updateTicket = async (projectId: string, ticketId: string, data: UpdateTicketRequest): Promise<Ticket> => {
  const response = await api.put(`/projects/${projectId}/tickets/${ticketId}`, data);
  return response.data.data;
};

// Delete a ticket
export const deleteTicket = async (projectId: string, ticketId: string): Promise<void> => {
  await api.delete(`/projects/${projectId}/tickets/${ticketId}`);
};

// Add a comment to a ticket
export const addComment = async (projectId: string, ticketId: string, conteudo: string): Promise<TicketComment> => {
  const response = await api.post(`/projects/${projectId}/tickets/${ticketId}/comments`, { conteudo });
  return response.data.data;
};

// Delete a comment
export const deleteComment = async (projectId: string, ticketId: string, commentId: string): Promise<void> => {
  await api.delete(`/projects/${projectId}/tickets/${ticketId}/comments/${commentId}`);
};

// Get tickets by service order
export const getTicketsByServiceOrder = async (serviceOrderId: string): Promise<Ticket[]> => {
  const response = await api.get(`/service-orders/${serviceOrderId}/tickets`);
  return response.data.data;
};
